import type { State, Action } from './typings'

import {
  openActivitySummaryProducer,
  closeActivitySummaryProducer,
  setActivitySummaryTabProducer,
  setActivitySummaryStatsProducer,
  setActivitySummaryFiltersProducer,
  setActivitySummaryOrderByProducer,
  setActivitySummaryTableStateProducer,
  setActivitySummaryStatsLoadingProducer,
  setEditActivityIdProducer,
  setEditStatusForActivityProducer,
  closeEditActivityProducer,
  setAnchorElProducer,
  updateActivityProducer,
  removeActivityProducer,
} from './actions'

export function reducer(state: State, action: Action): State {
  switch (action.type) {
    case 'activitySummary/open':
      return openActivitySummaryProducer(state)
    case 'activitySummary/close':
      return closeActivitySummaryProducer(state)
    case 'activitySummary/setTab':
      return setActivitySummaryTabProducer(state, action.payload)
    case 'activitySummary/setStats':
      return setActivitySummaryStatsProducer(state, action.payload)
    case 'activitySummary/setFilters':
      return setActivitySummaryFiltersProducer(state, action.payload)
    case 'activitySummary/setOrderBy':
      return setActivitySummaryOrderByProducer(state, action.payload)
    case 'activitySummary/setTableState':
      return setActivitySummaryTableStateProducer(state, action.payload)
    case 'activitySummary/setStatsLoading':
      return setActivitySummaryStatsLoadingProducer(state, action.payload)
    case 'activitySummary/setEditActivityId':
      return setEditActivityIdProducer(state, action.payload)
    case 'activitySummary/closeEditActivity':
      return closeEditActivityProducer(state)
    case 'activitySummary/setAnchorEl':
      return setAnchorElProducer(state, action.payload)
    case 'activitySummary/updateActivity':
      return updateActivityProducer(state, action.payload)
    case 'activitySummary/setEditStatusForActivity':
      return setEditStatusForActivityProducer(state, action.payload)
    case 'activitySummary/removeActivity':
      return removeActivityProducer(state, action.payload)
    default:
      return state
  }
}
